import React from 'react'
// @ts-ignore
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { Skeleton } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'

const StyledGroupContainer = styled.div`
  border-bottom: 1px solid;
  border-color: ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`

const StyledItemContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  border-bottom: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};

  &:last-child {
    border-bottom: none;
  }
`

const StyledLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
`

const StyledRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

const AVATAR_SKELETON_WIDTH = '48px'
const AVATAR_SKELETON_HEIGHT = '48px'

const AUTHOR_INFO_SKELETON_WIDTH = '120px'
const AUTHOR_INFO_SKELETON_HEIGHT = '40px'

const SIMPLE_BAR_SKELETON_WIDTH = '100%'
const SIMPLE_BAR_SKELETON_HEIGHT = '12px'

const LOADING_PLACEHOLDER_COUNT = 2

const LoadingRowGroup = () => {
  const theme = useDisplayTheme()

  return (
    <StyledGroupContainer mode={theme}>
      {Array(LOADING_PLACEHOLDER_COUNT)
        .fill(0)
        .map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <StyledItemContainer key={index} mode={theme}>
            <StyledLeft>
              <Skeleton
                mode={theme}
                variation="circle"
                width={AVATAR_SKELETON_WIDTH}
                height={AVATAR_SKELETON_HEIGHT}
                animation="wave"
              />
              <Skeleton
                mode={theme}
                variation="rectangle"
                width={AUTHOR_INFO_SKELETON_WIDTH}
                height={AUTHOR_INFO_SKELETON_HEIGHT}
                animation="wave"
              />
            </StyledLeft>
            <StyledRight>
              <Skeleton
                mode={theme}
                variation="rectangle"
                width={SIMPLE_BAR_SKELETON_WIDTH}
                height={SIMPLE_BAR_SKELETON_HEIGHT}
                animation="wave"
              />
            </StyledRight>
          </StyledItemContainer>
        ))}
    </StyledGroupContainer>
  )
}

export default LoadingRowGroup
